( function () {
	const INIT_EVENTS = {
		DOMContentLoaded: document,
	};

  const LOCAL_STORAGE_KEY = 'coronaria-servicearea';

	Object.entries( INIT_EVENTS ).forEach( ( [ event, element ] ) => {
		element.addEventListener( event, () => {
			init();
		} );
	} );

	const init = () => {

    const existingServicearea = getExistingServicearea();
    if ( existingServicearea ) {
      console.log( `📍 Servicearea: Saved value found (${existingServicearea})` );
    }

    const didSaveFromStrongHtmlAttribute = maybeSaveFromStrongHtmlAttribute();
    if ( ! didSaveFromStrongHtmlAttribute && ! existingServicearea ) {
      maybeSaveFromWeakHtmlAttribute();
    }

    // listen to custom event cor_filterable_option_selected
    window.addEventListener( 'cor_filterable_option_selected', ( event ) => {
      const { name, value } = event.detail;
      if ( name === 'servicearea[]' && value ) {
        localStorage.setItem( LOCAL_STORAGE_KEY, value );
        console.log( `📍 Servicearea: Saved value from filterable option (${value})` );
      }
    });


	};

  const getExistingServicearea = () => {
    const servicearea = localStorage.getItem( LOCAL_STORAGE_KEY );
    return servicearea ? servicearea : null;
  };

  const maybeSaveFromStrongHtmlAttribute = () => {
    const ATTRIBUTE = 'data-selected-servicearea-from-url';
    let didSave = false;
    const servicearea = document.querySelector( `[${ATTRIBUTE}]` );
    if ( servicearea ) {
      const value = servicearea.getAttribute( ATTRIBUTE );
      if ( value ) {
        localStorage.setItem( LOCAL_STORAGE_KEY, value );
        didSave = true;
        console.log( `📍 Servicearea: Saved value from strong HTML attribute (${value})` );
      }
    }
    return didSave;
  }

  const maybeSaveFromWeakHtmlAttribute = () => {
    const ATTRIBUTE = 'data-selected-servicearea-from-content';
    let didSave = false;
    const servicearea = document.querySelector( `[${ATTRIBUTE}]` );
    if ( servicearea ) {
      const value = servicearea.getAttribute( ATTRIBUTE );
      if ( value ) {
        localStorage.setItem( LOCAL_STORAGE_KEY, value );
        didSave = true;
        console.log( `📍 Servicearea: Saved value from weak HTML attribute (${value})` );
      }
    }
    return didSave;
  };

} )();
